module.exports = __webpack_public_path__ + "img/eliminar.55ec828b.svg";